var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeShipmentModel.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bulk Update Status Report")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeShipmentModel.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "suggestion"
  }, [_c('div', {
    staticClass: "radius"
  }, [_c('label', {
    staticClass: "text-muted"
  }, [_vm._v(" Success ")]), _vm._v(" "), _c('span', {
    staticClass: "dotSuccess"
  })]), _vm._v(" "), _c('div', {
    staticClass: "radius"
  }, [_c('label', {
    staticClass: "text-muted"
  }, [_vm._v(" Error ")]), _vm._v(" "), _c('span', {
    staticClass: "dotError"
  })])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isForwardBulkReportLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isForwardBulkReportLoader = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v(" Message ")])])]), _vm._v(" "), _c('tbody', [(Object.keys(this.showForwardBulkReportStatus).length > 0) ? _vm._l((_vm.showForwardBulkReportStatus), function(value, propertyName, index) {
    return _c('tr', {
      key: index,
      class: [value.code == 200 ? 'applysuccess' : 'applyErrorcss']
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(propertyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value.message))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm mt-4",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeShipmentModel()
      }
    }
  }, [_vm._v("close")])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dabc49e0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/common/ForwardBulkPodResultStatus.vue
// module id = 1149
// module chunks = 1